import { ORDERS_API_BASE } from '@/config/api';
const state = {
  newOrders: [], // Список новых заказов
};

const mutations = {
  SET_NEW_ORDERS(state, orders) {
    state.newOrders = orders; // Устанавливаем новые заказы
  },
  REMOVE_ORDER(state, orderId) {
    state.newOrders = state.newOrders.filter(order => order.id !== orderId); // Удаляем заказ
  },
};

const actions = {
  async fetchNewOrders({ commit, state }) {
    try {
      const response = await fetch(ORDERS_API_BASE + '/orders.php?filter[extendedStatus][]=new');
      const data = await response.json();

      if (data.orders) {
        const formattedOrders = data.orders.map(order => ({
          id: order.id,
          createdAt: order.createdAt,
          orderMethod: order.orderMethod,
          site: order.site,
        }));

        console.log('Полученные заказы:', formattedOrders);

        // Фильтрация для предотвращения дублирования
        const uniqueOrders = formattedOrders.filter(
          newOrder => !state.newOrders.find(existingOrder => existingOrder.id === newOrder.id)
        );

        commit('SET_NEW_ORDERS', uniqueOrders);
      } else {
        console.warn('Заказы не найдены.');
        commit('SET_NEW_ORDERS', []); // Очищаем заказы, если их нет
      }
    } catch (error) {
      console.error('Ошибка при получении новых заказов:', error);
    }
  },

  removeOrder({ commit }, orderId) {
    commit('REMOVE_ORDER', orderId); // Удаляем заказ по ID
  },
};

const getters = {
  getNewOrders: state => state.newOrders,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
